export const brl = (v) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 })

export const km = (v) => `${v.toLocaleString('pt-BR')} km`

export const STATUS = {
  disponivel: { label: 'Disponível', cls: 'bg-brand-50 text-brand-700' },
  reservado: { label: 'Reservado', cls: 'bg-amber-100 text-amber-700' },
  em_contrato: { label: 'Em contrato', cls: 'bg-slate-200 text-slate-600' },
  vendido: { label: 'Vendido', cls: 'bg-slate-200 text-slate-600' },
}

export const cars = [
  {
    id: 'creta-2022',
    nome: 'Hyundai Creta Comfort 1.0 Turbo',
    ano: '2022/2022',
    kmRodados: 45300,
    cambio: 'Automático',
    combustivel: 'Flex',
    carroceria: 'SUV',
    portas: 4,
    motor: '1.0 Turbo · 120 cv',
    cor: 'Vermelho',
    placaFinal: '7',
    fipe: 112900,
    unicoDono: true,
    consignado: false,
    status: 'disponivel',
    propostas: 2,
    fotos: ['/cars/13767773.jpg'],
    opcionais: ['Ar-condicionado', 'Direção elétrica', 'Central multimídia', 'Câmera de ré', 'Rodas de liga leve', 'Airbag', 'ABS', 'Vidros elétricos'],
    planos: [
      { id: 'p1', entrada: 5000, parcelas: 60, valor: 2090 },
      { id: 'p2', entrada: 8000, parcelas: 48, valor: 2190 },
      { id: 'p3', entrada: 12000, parcelas: 36, valor: 2290 },
    ],
  },
  {
    id: 'golf-2019',
    nome: 'Volkswagen Golf TSI Comfortline',
    ano: '2019/2019',
    kmRodados: 62100,
    cambio: 'Automático',
    combustivel: 'Flex',
    carroceria: 'Hatch',
    portas: 4,
    motor: '1.4 TSI · 150 cv',
    cor: 'Branco',
    placaFinal: '2',
    fipe: 94500,
    unicoDono: false,
    consignado: false,
    status: 'disponivel',
    propostas: 0,
    fotos: ['/cars/5471133.jpg', '/cars/31943403.jpg'],
    opcionais: ['Ar-condicionado', 'Direção elétrica', 'Central multimídia', 'Sensor de estacionamento', 'Rodas de liga leve', 'Airbag', 'ABS', 'Bancos de couro'],
    planos: [
      { id: 'p1', entrada: 4000, parcelas: 60, valor: 1790 },
      { id: 'p2', entrada: 7000, parcelas: 48, valor: 1890 },
      { id: 'p3', entrada: 10000, parcelas: 36, valor: 1990 },
    ],
  },
  {
    id: 'cruze-2020',
    nome: 'Chevrolet Cruze LT',
    ano: '2020/2020',
    kmRodados: 51200,
    cambio: 'Automático',
    combustivel: 'Flex',
    carroceria: 'Sedã',
    portas: 4,
    motor: '1.4 Turbo · 153 cv',
    cor: 'Cinza',
    placaFinal: '9',
    fipe: 89900,
    unicoDono: false,
    consignado: false,
    status: 'disponivel',
    propostas: 0,
    fotos: ['/cars/218719.jpg'],
    opcionais: ['Ar-condicionado', 'Direção elétrica', 'Central multimídia', 'Sensor de estacionamento', 'Rodas de liga leve', 'Airbag', 'ABS'],
    planos: [
      { id: 'p1', entrada: 4000, parcelas: 60, valor: 1690 },
      { id: 'p2', entrada: 7000, parcelas: 48, valor: 1790 },
      { id: 'p3', entrada: 10000, parcelas: 36, valor: 1890 },
    ],
  },
  {
    id: 'evoque-2015',
    nome: 'Range Rover Evoque Pure',
    ano: '2015/2015',
    kmRodados: 88700,
    cambio: 'Automático',
    combustivel: 'Gasolina',
    carroceria: 'SUV',
    portas: 2,
    motor: '2.0 Turbo · 240 cv',
    cor: 'Branco',
    placaFinal: '1',
    fipe: 129900,
    unicoDono: false,
    consignado: true,
    status: 'disponivel',
    propostas: 3,
    fotos: ['/cars/116675.jpg'],
    opcionais: ['Ar-condicionado dual zone', 'Bancos de couro', 'Central multimídia', 'Câmera de ré', 'Teto panorâmico', 'Rodas de liga leve 20"', 'Airbag', 'ABS'],
    planos: [
      { id: 'p1', entrada: 15000, parcelas: 48, valor: 3190 },
      { id: 'p2', entrada: 20000, parcelas: 36, valor: 3390 },
    ],
  },
  {
    id: 'corolla-2018',
    nome: 'Toyota Corolla XEi',
    ano: '2018/2018',
    kmRodados: 95600,
    cambio: 'Automático CVT',
    combustivel: 'Flex',
    carroceria: 'Sedã',
    portas: 4,
    motor: '2.0 · 154 cv',
    cor: 'Branco',
    placaFinal: '5',
    fipe: 84900,
    unicoDono: false,
    consignado: false,
    status: 'em_contrato',
    propostas: 0,
    fotos: ['/cars/10425102.jpg'],
    opcionais: ['Ar-condicionado', 'Direção elétrica', 'Central multimídia', 'Câmera de ré', 'Rodas de liga leve', 'Airbag', 'ABS'],
    planos: [
      { id: 'p1', entrada: 4000, parcelas: 60, valor: 1590 },
      { id: 'p2', entrada: 8000, parcelas: 48, valor: 1690 },
    ],
  },
]

export const getCar = (id) => cars.find((c) => c.id === id)

export const minParcela = (car) => Math.min(...car.planos.map((p) => p.valor))
